import { useSelector } from 'store';
import useAuth from './useAuth';
import useErrorSnackbar from './useErrorSnackbar';

/** nodemailer attachment shape, passed through to the `mail` doc. Prefer `path`
 *  (a download URL) over inline base64 `content` so the `mail` doc stays under
 *  Firestore's 1 MiB document limit for large PDFs. */
export interface EmailAttachment {
  filename: string;
  path?: string;
  content?: string;
  encoding?: string;
  contentType?: string;
}

export interface FirebaseEmail {
  to: string;
  cc?: string | string[];
  message: {
    subject: string;
    html: string;
    attachments?: EmailAttachment[];
  };
}

export default function useSendEmail() {
  const { db, user } = useAuth();
  const mailRef = db.collection('mail');
  const errorSnackbar = useErrorSnackbar();
  const { emailActive } = useSelector((state) => state.config?.mainConfig?.app || {});

  const sendEmail = async (emailObject: FirebaseEmail) => {
    if (!emailActive && user?.isStaff) {
      return errorSnackbar({ message: 'Email is not active' } as Error);
    }

    try {
      if (!emailObject.to) throw new Error('No email address provided');
      const docRef = await mailRef.add({ ...emailObject });
      console.log('Email sent with ID: ', docRef.id);
    } catch (error) {
      console.error('Error adding email: ', error);
    }
  };

  return sendEmail;
}
